/**
 * @ngInject
 */
function Breakpoints () {
    var breakpoints = {
        small: window.matchMedia('(min-width: 600px)'),
        medium: window.matchMedia('(min-width: 992px)'),
        large: window.matchMedia('(min-width: 1350px)')
    };
    var api = {};
    api.matches = function matches(breakpoint) {
        return (breakpoints[breakpoint].matches);
    };
    api.getLayout = function getLayout() {
        if (breakpoints.large.matches) return 'large';
        if (breakpoints.medium.matches) return 'medium';
        if (breakpoints.small.matches) return 'small';
        return 'x-small';
    };
    return api;
}